// extracted by mini-css-extract-plugin
export default {"root":"ListOfParticipants_root__yRAtf"};